import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO } from "@/lib/hooks";

export default function ServicesPage() {
  const [services, setServices] = useState([]);
  useSEO({ title: "Services de dépannage et remorquage — Depann7", description: "Découvrez tous nos services : dépannage, remorquage, transport, sortie de fourrière, assistance routière en Île-de-France." });
  useEffect(() => { api.get("/services").then((r) => setServices(r.data || [])).catch(() => {}); }, []);

  return (
    <div className="bg-white">
      <div className="bg-ink-900 text-white py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-6">
          <h1 className="text-3xl lg:text-4xl font-extrabold">Nos Services</h1>
          <p className="text-ink-300 mt-2 max-w-2xl">Une solution adaptée à chaque situation, jour et nuit, partout en Île-de-France.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((s) => (
          <Link key={s.slug} to={`/services/${s.slug}`} className="group bg-white border border-surface-200 hover:border-brand rounded-2xl overflow-hidden transition-all hover:shadow-card" data-testid={`services-card-${s.slug}`}>
            {s.image_url && <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${s.image_url})` }} />}
            <div className="p-6 flex-1 flex flex-col">
              <div className="font-bold text-lg text-txt-900">{s.title}</div>
              <p className="text-txt-500 text-sm mt-2 flex-1">{s.short_description}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-brand text-sm font-bold">{s.tarif_indicatif}</span>
                <ArrowRight size={18} className="text-brand group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
